export default {
  title: 'Projects',
};
